/*
 * COJ Special Order — PDP variant-aware shipping-delay message + cart-line properties.
 * Mirrors the badge-system data/JS pattern.
 *
 * Reads a variantId -> {enabled, message} map emitted by snippets/condor-special-order-message.liquid.
 * On the selected variant changing: shows/hides the PDP message and toggles two hidden
 * cart-line property inputs on the product form:
 *   properties[_condor_special_order] = 'true'
 *   properties[_condor_message]        = <message text>
 * Disabled inputs are not submitted, so non-Special-Order variants write nothing.
 *
 * No-form fallback: on a template with no add-to-cart form (e.g. a coming-soon
 * layout), the selected variant can't be read, so the message is shown for the
 * first Special Order variant in the map. On normal PDPs a form exists, so this
 * fallback never triggers and the message stays variant-accurate.
 *
 * findAddToCartForm() requires the candidate to contain a real submit control
 * before picking it (fixes a prior bug where properties were written to a
 * Shop Pay installment form with no submit button and never reached the cart).
 */
(function () {
  'use strict';

  var DATA_SELECTOR = 'script.condor-so-data';
  var instances = [];

  function parseData(el) {
    try { return JSON.parse((el.textContent || '{}').trim()); } catch (e) { return {}; }
  }

  function findAddToCartForm() {
    var candidates = document.querySelectorAll('product-form form, form[action*="/cart/add"]');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].querySelector('button[type="submit"], [name="add"]')) return candidates[i];
    }
    return candidates[0] || null;
  }

  function getVariantId(form) {
    if (form) {
      var input = form.querySelector('[name="id"]');
      if (input && input.value) return String(input.value);
    }
    var pageInput = document.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
    if (pageInput && pageInput.value) return String(pageInput.value);
    var v = new URLSearchParams(window.location.search).get('variant');
    return v ? String(v) : null;
  }

  function ensureInputs(form) {
    if (!form) return null;
    var flag = form.querySelector('input[data-condor-flag]');
    var msg = form.querySelector('input[data-condor-msg]');
    if (!flag) {
      flag = document.createElement('input');
      flag.type = 'hidden';
      flag.name = 'properties[_condor_special_order]';
      flag.setAttribute('data-condor-flag', '');
      flag.disabled = true;
      form.appendChild(flag);
    }
    if (!msg) {
      msg = document.createElement('input');
      msg.type = 'hidden';
      msg.name = 'properties[_condor_message]';
      msg.setAttribute('data-condor-msg', '');
      msg.disabled = true;
      form.appendChild(msg);
    }
    return { flag: flag, msg: msg };
  }

  function update(inst) {
    var vid = getVariantId(inst.form);
    if (!vid && !inst.form) {
      var keys = Object.keys(inst.map);
      if (keys.length) vid = keys[0];
    }
    var data = vid ? inst.map[vid] : null;
    var active = !!(data && data.enabled);
    if (active) {
      if (inst.textEl) inst.textEl.textContent = data.message || '';
      inst.msgEl.classList.add('is-visible');
      if (inst.inputs) {
        inst.inputs.flag.value = 'true';
        inst.inputs.msg.value = data.message || '';
        inst.inputs.flag.disabled = false;
        inst.inputs.msg.disabled = false;
      }
    } else {
      inst.msgEl.classList.remove('is-visible');
      if (inst.inputs) {
        inst.inputs.flag.disabled = true;
        inst.inputs.msg.disabled = true;
        inst.inputs.flag.value = '';
        inst.inputs.msg.value = '';
      }
    }
    inst.lastVid = vid;
  }

  function init() {
    var dataEls = document.querySelectorAll(DATA_SELECTOR);
    Array.prototype.forEach.call(dataEls, function (dataEl) {
      var root = dataEl.closest('[data-condor-so]') || dataEl.parentNode;
      if (!root || root.__condorBound) return;
      root.__condorBound = true;
      var form = root.closest('form') || findAddToCartForm();
      var inst = {
        root: root,
        map: parseData(dataEl),
        msgEl: root.querySelector('.condor-so__msg'),
        textEl: root.querySelector('.condor-so__msg-text'),
        form: form,
        inputs: ensureInputs(form),
        lastVid: null
      };
      if (!inst.msgEl) return;
      instances.push(inst);
      update(inst);
      if (form) form.addEventListener('change', function () { update(inst); });
    });
    if (instances.length && !window.__condorSoPoll) {
      window.__condorSoPoll = setInterval(function () {
        instances.forEach(function (inst) {
          if (getVariantId(inst.form) !== inst.lastVid) update(inst);
        });
      }, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
